module.exports = __webpack_public_path__ + "img/Pinturas-no-solo.f507d138.png";